export const globalAction = {
    SET_THEME: "SET_THEME"
};